export class Lohnsumme {
  bezahlteLohnsummeMitarbeitende: number;
  bezahlteLohnsummeMitarbeitendeProzent: string;
  bezahlteLohnsummeFrauen: number;
  bezahlteLohnsummeFrauenProzent: string;
  bezahlteLohnsummeMaenner: number;
  bezahlteLohnsummeMaennerProzent: string;
  standardisierteLohnsummeMitarbeitende: number;
  standardisierteLohnsummeMitarbeitendeProzent: string;
  standardisierteLohnsummeFrauen: number;
  standardisierteLohnsummeFrauenProzent: string;
  standardisierteLohnsummeMaenner: number;
  standardisierteLohnsummeMaennerProzent: string;
}
